import workspaceQuery from 'graphql/queries/customer/CustomerProductHistoryWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/product/ProductFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const CustomerProductHistory: EntityType = {
  type: 'Product',
  title: 'Customer Product History',
  workspaceUrl: '/Customers/ProductHistory/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'CUSTOMER_PRODUCT_HISTORY',
};

export default CustomerProductHistory;
